// helpers/HelperConstants.tsx

export const ACCOUNT_TYPES = [
  'Cash', 'Checking', 'Savings', 'Credit Card', 'Investment', 'Cryptocurrency', 'Loan', 'Other'
];

export const BUSINESS_TYPE_ENUM : { [key: string]: string} = {
    "Auto & Transport": "at",
    "Bills & Utilities": "bu",
    "Business Services": "bs",
    "Education": "ed",
    "Entertainment": "e",
    "Fees & Charges": "fc",
    "Financial": "fn",
    "Food": "f",
    "Gift & Donations": "gd",
    "Health & Fitness": "hf",
    "Home": "h",
    "Income": "in",
    "Investments": "iv",
    "Kids": "k",
    "Loans": "l",
    "Misc Expenses": "m",
    "Personal Care": "pc",
    "Pets": "p",
    "Shopping": "s",
    "Travel": "t",
    "Dining": "d",
}

export const DEFAULT_USER_ID = 1;

export const PLACEHOLDER_IMG_URL = 'https://api.dicebear.com/7.x/notionists/svg?seed=finova&backgroundColor=1e90a8';

export const SUPPORT_SUBJECTS = [
    'General Inquiry',
    'Feature Request',
    'Account Issue',
    'Bug Report'
] as const;
export type SupportSubject = typeof SUPPORT_SUBJECTS[number];

export const DEFAULT_MAX_CHARACTERS = 50;
